export default __webpack_public_path__ + "img/0f63a9b296fb1e2a5baff5e96e605783.png";